module.exports = __webpack_public_path__ + "static/media/img134.73f7cda2.jpg";